<template>
    <div class="m-right-manage">
        <h4 class="title">权限管理</h4>
        <div class="admin">
            <h5 class="title sub-title">管理员<span class="tips">可设置风险操作保护、风险操作提醒等账户安全</span></h5>
            <div class="manager">
                <img :src="adminInfo.face" class="face-admin" width="60" height="60"/>
                <div class="name">{{adminInfo.nickName}}</div>
                <div class="mid">mid:{{mid}}</div>
            </div>
        </div>
        <div class="members">
            <h5 class="title sub-title">成员管理<span class="tips">管理员可添加小程序项目成员，并配置成员的权限</span></h5>
            <div class="op">
                <el-button v-if="!isEdit" size="medium" class="btn btn-1" type="text" @click="edit(0)">编辑</el-button>
                <el-button v-if="isEdit" size="medium" class="btn btn-2" type="text" @click="cancel(0)">取消</el-button>
                <el-button v-if="isEdit" size="medium" class="btn btn-1" type="text" @click="judgeSaveIsNeed('save')">保存</el-button>
                <el-button class="btn btn-add" size="medium" @click="addMembers(0)" :disabled="isLoading">添加成员</el-button>
            </div>
            <el-table
                :data="list"
                :span-method="arraySpanMethod"
                :header-cell-style="{'background-color': '#EFF4FC', 'color': '#5C667E'}"
            >
                <el-table-column label="头像" align="center" width="160">
                    <template slot-scope="scope">
                        <div v-if="scope.row.isDeleted == '1'" class="redo">保存删除后将生效，<el-button type="text" @click="deleteMember(scope.row, 0, 0)">撤销删除</el-button></div>
                        <div v-else class="face">
                            <img :src="scope.row.face" width="68px" @error="faceErr(scope.row)" :class="{'face-err': faceErr}">
                            <div class="delete" v-if="isEdit && !scope.row.admin" @click="deleteMember(scope.row, 0, 1)"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="昵称" prop="nickName" align="center" width="250">
                        <template slot-scope="scope">
                            {{scope.row.nickName}}
                            <span class="admin-label" v-if="scope.row.admin">管理员</span>
                        </template>
                    </el-table-column>
                <el-table-column prop="mid" align="center" width="200">
                    <template slot="header" slot-scope="scope">
                        <div class="header-manager">
                            mid
                            <el-popover popper-class="title-tips" width="247" trigger="hover">
                                <div class="content">
                                    <div class="sub-item">B站帐号，用于使用开发者工具、小程序体验版预览</div>
                                </div>
                                <i slot="reference" class="icon-detail"></i>
                            </el-popover>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template slot="header" slot-scope="scope">
                        <div class="header-manager">
                            <span class="header-type">开发者权限</span>
                            <el-popover popper-class="title-tips" width="247" trigger="hover">
                                <div class="content">
                                    <div class="sub-item">开发者权限，可使用开发者工具（IDE）、登录开发者后台查看、可访问体验版小程序</div>
                                </div>
                                <i slot="reference" class="icon-detail"></i>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div v-if="isEdit && !scope.row.admin" class="edit-dev" :class="{'checked': scope.row.developer == '1'}" @click="changeValue(scope.row, 'developer', 0)"></div>
                        <div v-else><i :class="scope.row.developer == '1' ? 'el-icon-check' : 'el-icon-minus'"></i></div>
                    </template>
                </el-table-column>
                <el-table-column align="center">
                    <template slot="header" slot-scope="scope">
                        <div class="header-manager">
                            运营权限
                            <el-popover :offset="192" popper-class="title-tips" width="247" trigger="hover">
                                <div class="content">
                                    <div class="sub-item">运营权限，支持修改设置模块（暂停服务、最低支持版本修改、域名配置等）、开发管理模块（发布线上、版本回退）、权限管理模块（体验版成员、体验版设备添加）、可访问体验版小程序</div>
                                </div>
                                <i slot="reference" class="icon-detail"></i>
                            </el-popover>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <div v-if="isEdit && !scope.row.admin" class="edit-dev" :class="{'checked': scope.row.operation == '1'}" @click="changeValue(scope.row, 'operation', 0)"></div>
                        <div v-else><i :class="scope.row.operation == '1' ? 'el-icon-check' : 'el-icon-minus'"></i></div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :total="total" :current-page.sync="pageNum" :page-size="pageSize" @current-change="getList" layout="->, prev, pager, next" prev-text="上一页" next-text="下一页" class="pager" background></el-pagination>
        </div>
        <simple-tab :tab-list="tabList" :active.sync="active" class="title"></simple-tab>
        <div class="manage-content">
            <div class="members" v-show="!active">
                <!-- 体验成员管理 -->
                <h5 class="title sub-title"><span class="tips">体验成员可以在 bilibili APP 内访问体验版小程序</span></h5>
                <div class="op">
                    <el-button v-if="!previewIsEdit" size="medium" class="btn btn-1" type="text" @click="edit(3)">编辑</el-button>
                    <el-button v-if="previewIsEdit" size="medium" class="btn btn-2" type="text" @click="cancel(3)">取消</el-button>
                    <el-button v-if="previewIsEdit" size="medium" class="btn btn-1" type="text" @click="judgeSaveIsNeed('previewSave')">保存</el-button>
                    <el-button class="btn btn-add" size="medium" @click="addMembers(3)" :disabled="previewIsLoading">添加成员</el-button>
                </div>
                <el-table
                    :data="previewList"
                    :span-method="previewArraySpanMethod"
                    :header-cell-style="{'background-color': '#EFF4FC', 'color': '#5C667E'}"
                >
                    <span slot="empty">暂未添加体验成员，<el-button type="text" @click="addMembers(3)" size="small">请添加成员</el-button></span>
                    <el-table-column label="头像" align="center" width="180">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isDeleted == '1'" class="redo">保存删除后将生效，<el-button type="text" @click="deleteMember(scope.row, 3, 0)">撤销删除</el-button></div>
                            <div v-else class="face">
                                <img :src="scope.row.face" width="68px" @error="faceErr(scope.row)" :class="{'face-err': faceErr}">
                                <div class="delete" v-if="previewIsEdit && !scope.row.admin" @click="deleteMember(scope.row, 3, 1)"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="昵称" prop="nickName" align="center" width="250">
                        <template slot-scope="scope">
                            {{scope.row.nickName}}
                            <span class="admin-label" v-if="scope.row.admin">管理员</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="mid" prop="mid" align="center"></el-table-column>
                    <el-table-column label="备注" align="center" width="250">
                        <template slot-scope="scope">
                            <el-input v-if="previewIsEdit && !scope.row.admin" v-model="scope.row.remark" @change="changeValue(scope.row, 'remarkMem', 3)" size="medium"></el-input>
                            <div v-else>{{scope.row.remark}}<i class="el-icon-minus" v-if="!scope.row.remark"></i></div>
                        </template>
                    </el-table-column>
                    <el-table-column label="体验权限" align="center">
                        <template slot-scope="scope">
                            <div v-if="previewIsEdit && !scope.row.admin" class="edit-dev" :class="{'checked': scope.row.preview == '1'}" @click="changeValue(scope.row, 'preview', 3)"></div>
                            <div v-else><i :class="scope.row.preview == '1' ? 'el-icon-check' : 'el-icon-minus'"></i></div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination :total="previewTotal" :current-page.sync="previewPageNum" :page-size="previewPageSize" @current-change="getPreviewList" layout="->, prev, pager, next" prev-text="上一页" next-text="下一页" class="pager" background></el-pagination>
            </div>
            <!-- 设备管理 -->
            <div class="members" v-show="active == 1">
                <h5 class="title sub-title">
                    <span class="tips no-margin-tips">仅以下添加的设备号, 访问当前小程序预览版本时，允许在Bilibili App内未登录状态下访问</span>
                </h5>
                <div class="op">
                    <el-button v-if="!devicesIsEdit" size="medium" class="btn btn-1" type="text" @click="edit(2)">编辑</el-button>
                    <el-button v-if="devicesIsEdit" size="medium" class="btn btn-2" type="text" @click="cancel(2)">取消</el-button>
                    <el-button v-if="devicesIsEdit" size="medium" class="btn btn-1" type="text" @click="judgeSaveIsNeed('saveDevices')">保存</el-button>
                    <el-button class="btn btn-add" size="medium" @click="addDevices" :disabled="deviceIsLoading">添加设备</el-button>
                </div>
                <el-table
                    :data="devicesList"
                    :span-method="arraySpanMethodForDevice"
                    :header-cell-style="{'background-color': '#EFF4FC', 'color': '#5C667E'}"
                    key="devicesTable"
                    >
                    <span slot="empty">暂未添加体验设备，<el-button type="text" @click="addDevices" size="small">请添加设备</el-button></span>
                    <el-table-column label="设备号" align="center" width="300" prop="buvid">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isDeleted == '1'" class="redo">保存删除后将生效，<el-button type="text" @click="deleteMember(scope.row, 2, 0)">撤销删除</el-button></div>
                            <div v-else class="buvid">
                                <div class="buvid_num">{{scope.row.buvid}}</div>
                                <div class="delete" v-if="devicesIsEdit" @click="deleteMember(scope.row, 2, 1)"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="备注" prop="remark" align="center" width="350">
                        <template slot-scope="scope">
                            <div v-if="devicesIsEdit">
                                <el-input type="textarea" :rows="2" v-model="scope.row.remark" @change="changeValue(scope.row, 'remarkDev', 2)" size="medium" :maxlength="30"></el-input>
                                <div class="len-remark">{{scope.row.remark.length}} / 30</div>
                            </div>
                        <div v-else>{{scope.row.remark}}</div>
                    </template>
                    </el-table-column>
                    <el-table-column label="创建时间" prop="ctime" align="center" width="200">
                        <template slot-scope="scope">
                            {{formatDate(scope.row.ctime)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="预览权限" align="center">
                        <template slot-scope="scope">
                            <div ><i class="el-icon-check"></i></div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination :total="devicesTotal" :current-page.sync="pageNum" :page-size="pageSize" @current-change="getDevicesList" layout="->, prev, pager, next" prev-text="上一页" next-text="下一页" class="pager" background></el-pagination>
            </div>
        </div>
        <confirm :visible.sync="ConfirmVisible">
            <h4 class="title-dia" slot="title">{{dialogInfo[flag].title}}</h4>
            <p>{{dialogInfo[flag].content}}</p>
            <span slot="op-btns" class="op-btns">
                <btn v-for="(item, index) in dialogInfo[flag].btns" :key="index" :type="item.type" :info="item.label" @click="item.clickEvent"></btn>
            </span>
        </confirm>
        <add-devices-dialog :visible.sync="addDevicesDialogVisible" v-if="addDevicesDialogVisible" :appId="appId" @close="closeAddDialog" @refresh="getDevicesList"></add-devices-dialog>
    </div>
</template>
<script>
import SimpleTab from '@/components/SimpleTab.vue';
import Confirm from '@/components/Confirm.vue';
import Btn from '@/components/Button.vue';
import AddDevicesDialog from '@/components/rights/AddDevicesDialog.vue';

import dao from '@/lib/dao';
import bus from '@/lib/bus';
import formatDate from '@/lib/formatDate';
import defaultFace from '@/assets/default-face@2x.png';

const LIMIT = 50;

export default {
    beforeRouteLeave(to, from, next) {
        let saveIsNeed = this.judgeSaveIsNeed('leaveSave');
        if (this.editable && this.judgeSaveIsNeed) {
            this.routeInfo = to;
            next(false);
        } else {
            next();
        }
    },
    components: {
        SimpleTab,
        Confirm,
        Btn,
        AddDevicesDialog
    },
    computed: {
        mid() {
            if (bus.mid) {
                this.getAdmin();
            }
            return bus.mid || null;
        },
        editable: {
            get() {
                return this.devicesIsEdit || this.isEdit || this.previewIsEdit
            },
            set() {

            }
        }
    },
    watch: {
        active(val) {
            this.devicesIsEdit = false;
            this.previewIsEdit = false;
            this.routeInfo = {};
            if (val) {
                this.getDevicesList();
            } else {
                this.getPreviewList();
            }
        }
    },
    data() {
        const self = this;
        return {
            bus,
            adminInfo: {
                admin: true,
                mid: '',
                face: '',
                developer: '1',
                preview: '1',
                nickName: ''
            },
            membersList: [],
            devicesList: [],
            modifyInfo: {},
            devicesModifyInfo: {},
            pageSize: 10,
            pageNum: 1,
            appId: '',
            devicesIsEdit: false,
            membersIsEdit: false,
            isLoading: true,
            ConfirmVisible: false,
            type: 'saveMembres',
            routeInfo: {
                path: '/addMembers/'
            },
            active: 0,
            userType: 0,
            addDevicesDialogVisible: false,
            list: [],
            modifyInfo: {},
            total: 0,
            devicesTotal: 0,
            pageSize: 5,
            pageNum: 1,
            appId: '',
            previewList: [],
            previewTotal: 0,
            previewPageSize: 5,
            previewPageNum: 1,
            previewModifyInfo: {},
            previewIsEdit: false,
            previewIsLoading: true,
            type: 0,
            routeInfo: {
                path: '/addMembers/'
            },
            dialogInfo: {
                'save': {
                    title: '确认修改成员权限信息?',
                    content: '请确认此次修改，保存后立即生效',
                    btns: [
                        {
                            label: '确认',
                            type: 0,
                            clickEvent() {
                                self.save(self.getList, 0);
                            }
                        }
                    ]
                },
                'previewSave': {
                    title: '确认修体验成员信息?',
                    content: '请确认此次修改，保存后立即生效',
                    btns: [
                        {
                            label: '确认',
                            type: 0,
                            clickEvent() {
                                self.save(self.getPreviewList, 3);
                            }
                        }
                    ]
                },
                'saveDevices': {
                    title: '确认修改设备号权限信息?',
                    content: '请确认此次修改，保存后立即生效',
                    btns: [
                        {
                            label: '确认',
                            type: 0,
                            clickEvent() {
                                self.save(self.getDevicesList, 2);
                            }
                        }
                    ]
                },
                'leaveSave': {
                    title: '当前页面存在修改内容，是否需要保存?',
                    content: '',
                    btns: [
                        {
                            label: '放弃',
                            type: 1,
                            clickEvent() {
                                self.cancel(3);
                                self.cancel(0);
                                self.cancel(2);
                                self.leave();
                            }
                        },
                        {
                            label: '保存',
                            type: 0,
                            clickEvent() {
                                self.save(self.leave, self.type);
                            }
                        }
                    ]
                }
            },
            active: 0,
            tabList: ['体验版成员管理', '体验版设备管理'],
            addDevicesDialogVisible: false,
            devicesList: [],
            modifyInfo: {},
            devicesModifyInfo: {},
            devicesIsEdit: false,
            deviceIsLoading: true,
            isEdit: false,
            flag: 'save'
        }
    },
    methods: {
        faceErr(row) {
            row.face = defaultFace;
            this.$set(row, 'faceErr', true)
        },
        getAdmin() {
            dao.shop.checkMid({
                mid: bus.mid
            }).then(data => {
                this.adminInfo.mid = data.mid;
                this.adminInfo.face = data.face;
                this.adminInfo.nickName = data.nick;
                this.getList();
            }).catch(msg => this.$message.error(msg));
        },
        getList() {
            dao.shop.getMemberList({
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                appId: this.appId,
                userType: 0
            }).then(data => {
                this.isLoading = false;
                data.list = data.list || [];
                data.list.unshift({
                    admin: true,
                    nickName: this.adminInfo.nickName,
                    developer: '1',
                    operation: '1',
                    mid: this.adminInfo.mid,
                    face: this.adminInfo.face
                });
                if (this.isEdit && JSON.stringify(this.modifyInfo) !== '{}') {
                    this.list = data.list.map(item => {
                        if (this.modifyInfo[item.staff]) {
                            item = { ...item, ...this.modifyInfo[item.staff] };
                        }
                        return item;
                    })
                } else {
                    this.list = data.list;
                }
                this.total = data.total;
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        getPreviewList() {
            dao.shop.getMemberList({
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                appId: this.appId,
                userType: 3
            }).then(data => {
                this.previewIsLoading = false;
                this.previewTotal = data.total;
                if (this.previewIsEdit && JSON.stringify(this.previewModifyInfo) !== '{}') {
                    this.previewList = data.list.map(item => {
                        if (this.previewModifyInfo[item.mid]) {
                            item = { ...item, ...this.previewModifyInfo[item.mid] };
                        }
                        return item;
                    })
                } else {
                    this.previewList = data.list;
                }
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        previewArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (row.isDeleted == 1) {
                if (columnIndex === 0) {
                    return [1, 5];
                } else {
                    return [0, 0];
                }
            }
        },
        getDevicesList() {
            dao.shop.getMemberList({
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                appId: this.appId,
                userType: 2
            }).then(data => {
                this.deviceIsLoading = false;
                this.devicesTotal = data.total;
                if (this.devicesIsEdit && JSON.stringify(this.devicesModifyInfo) !== '{}') {
                    this.devicesList = data.list.map(item => {
                        if (this.devicesModifyInfo[item.buvid]) {
                            item.buvid = this.devicesModifyInfo[item.buvid].buvid;
                            item.remark = this.devicesModifyInfo[item.buvid].remark;
                            item.isDeleted = this.devicesModifyInfo[item.buvid].isDeleted;
                        }
                        return item;
                    })
                } else {
                    this.devicesList = data.list;
                }
            }).catch(msg => {
                this.$message.error(msg);
            });
        },
        addDevices() {
            this.routeInfo = {
                path: '/rightsmng/'
            };
            if (this.devicesIsEdit && this.judgeSaveIsNeed('leaveSave')) {
                return;
            } else {
                this.addDevicesDialogVisible = true;
            }
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (row.isDeleted == 1) {
                if (columnIndex === 0) {
                    return [1, 4];
                } else {
                    return [0, 0];
                }
            }
        },
        arraySpanMethodForDevice({ row, column, rowIndex, columnIndex }) {
            if (row.isDeleted == 1) {
                if (columnIndex === 0) {
                    return [1, 4];
                } else {
                    return [0, 0];
                }
            }
        },
        closeConfirm() { },
        edit(type) {
            if (type == 0) { // 成员
                if (!this.adminInfo.admin) {
                    this.$message.error('你没有操作权限，请联系管理员。');
                    return;
                }
                this.isEdit = true;
                this.modifyInfo = {};
            } else if (type == 3) { // 体验成员
                this.previewIsEdit = true;
                this.previewModifyInfo = {};
            } else { // 体验设备
                this.devicesIsEdit = true;
                this.devicesModifyInfo = {};
            }
        },
        cancel(type) {
            if (type === 0) { // 成员
                this.isEdit = false;
                this.modifyInfo = {};
                this.getList();
            } else if (type == 3) { // 体验成员
                this.previewIsEdit = false;
                this.previewModifyInfo = {};
                this.getPreviewList();
            } else { // 体验设备
                this.devicesIsEdit = false;
                this.devicesModifyInfo = {};
                this.getDevicesList();
            }
        },
        judgeSaveIsNeed(flag) {
            switch (flag) {
                case 'save':
                    if (JSON.stringify(this.modifyInfo) == "{}") {
                        this.cancel(0);
                        return false;
                    } else {
                        this.ConfirmVisible = true;
                        this.flag = flag;
                        return true;
                    }
                    break;
                case 'previewSave':
                    if (JSON.stringify(this.previewModifyInfo) == "{}") {
                        this.cancel(3);
                        return false;
                    } else {
                        this.ConfirmVisible = true;
                        this.flag = flag;
                        return true;
                    }
                case 'saveDevices':
                    if (JSON.stringify(this.devicesModifyInfo) == "{}") {
                        this.cancel(2);
                        return false;
                    } else {
                        this.ConfirmVisible = true;
                        this.flag = flag;
                        return true;
                    }
                case 'leaveSave':
                    if (JSON.stringify(this.previewModifyInfo) == "{}" && JSON.stringify(this.modifyInfo) == "{}" && JSON.stringify(this.devicesModifyInfo) == "{}") {
                        this.cancel(0);
                        this.cancel(3);
                        this.cancel(2);
                        this.ConfirmVisible = false;
                        return false;
                    } else {
                        this.ConfirmVisible = true;
                        this.flag = flag;
                        return true;
                    }
                default:
                    break;
            }
        },
        leave() {
            // this.$router.push(this.routeInfo);
            let { path = '' } = this.routeInfo;
            if (this.active == 1) {
                if (path.indexOf('rightsmng') === -1) {
                    this.$router.push(this.routeInfo);
                } else {
                    this.addDevicesDialogVisible = true;
                    this.ConfirmVisible = false;
                }
            } else {
                if (path.indexOf('/addMembers') !== -1) {
                    this.addMembers();
                } else {
                    this.$router.push(this.routeInfo);
                }
            }
        },
        save(cb = () => { }, type) {
            this.type = type;
            let modifyList = [];
            if (type === 0) {
                Object.keys(this.modifyInfo).forEach(key => {
                    if (this.modifyInfo[key].isDeleted == 1) {
                        this.total--;
                    }
                    modifyList.push(this.modifyInfo[key])
                });
            } else if (type === 3) {
                Object.keys(this.previewModifyInfo).forEach(key => {
                    if (this.previewModifyInfo[key].isDeleted == 1) {
                        this.previewTotal--;
                    }
                    modifyList.push(this.previewModifyInfo[key])
                });
            } else if (type === 2) {
                Object.keys(this.devicesModifyInfo).forEach(key => {
                    if (this.devicesModifyInfo[key].isDeleted == 1) {
                        this.devicesTotal--;
                    }
                    modifyList.push(this.devicesModifyInfo[key])
                });
            } else { // 离开保存
                Object.keys(this.modifyInfo).forEach(key => {
                    if (this.modifyInfo[key].isDeleted == 1) {
                        this.total--;
                    }
                    modifyList.push(this.modifyInfo[key])
                });
                Object.keys(this.previewModifyInfo).forEach(key => {
                    if (this.previewModifyInfo[key].isDeleted == 1) {
                        this.previewTotal--;
                    }
                    modifyList.push(this.previewModifyInfo[key])
                });
                Object.keys(this.devicesModifyInfo).forEach(key => {
                    if (this.devicesModifyInfo[key].isDeleted == 1) {
                        this.devicesTotal--;
                    }
                    modifyList.push(this.devicesModifyInfo[key])
                });
            }
            if (!this.devicesIsEdit) {
                dao.shop.modifyMembers({
                    appId: this.appId,
                    updateMemberList: modifyList,
                    userType: this.type
                }).then(data => {
                    this.ConfirmVisible = false;
                    if (type === 0) {
                        this.isEdit = false;
                    } else if (type === 3) {
                        this.previewIsEdit = false;
                    } else if (type === 2) {
                        this.devicesIsEdit = false;
                    } else {
                        this.isEdit = false;
                        this.previewIsEdit = false;
                        this.devicesIsEdit = false;
                    }
                    cb();
                }).catch(msg => {
                    this.$message.error(msg);
                });
            } else {
                dao.shop.updateDevices({
                    appId: this.appId,
                    miniAppMemberBuvidUpdateList: modifyList,
                    userType: type
                }).then(data => {
                    this.ConfirmVisible = false;
                    this.devicesIsEdit = false;
                    cb();
                }).catch(msg => {
                    this.$message.error(msg);
                });
            }
        },
        addMembers(type) {
            this.type = type;
            if (type === 0 && !this.adminInfo.admin) {
                this.$message.error('你没有操作权限，请联系管理员。');
                return;
            }
            if ((type === 0 && this.total === LIMIT) || (type == 3 && this.previewTotal === LIMIT)) {
                this.ConfirmVisible = false;
                this.$message({
                    type: 'error',
                    message: '成员人数已达上限，请删除后再添加',
                    duration: 3000
                });
                return;
            }

            this.$router.push({
                path: '/addMembers/' + this.appId,
                query: {
                    addedNo: type === 0 ? this.total : this.previewTotal,
                    userType: this.type
                }
            })
        },
        deleteMember(row, manageType, delType) {
            this.$set(row, 'isDeleted', delType);
            let param = {
                remark: row.remark,
                developer: row.developer,
                operation: row.operation,
                preview: row.preview,
                isDeleted: row.isDeleted,
                mid: row.mid
            };
            if (manageType === 2) {
                let param2 = {
                    remark: row.remark,
                    buvid: row.buvid,
                    ctime: row.ctime,
                    isDelete: row.isDeleted,
                    mid: row.mid
                };
                this.devicesModifyInfo[row.buvid] = param2;
                this.devicesModifyInfo[row.buvid].buvid = row.buvid;
            } else if (manageType === 0) {
                this.modifyInfo[row.mid] = {
                    mid: row.mid,
                    developer: row.developer,
                    preview: row.preview,
                    operation: row.operation,
                    isDeleted: row.isDeleted
                };
            } else {
                this.previewModifyInfo[row.mid] = param;
                this.previewModifyInfo[row.mid].mid = row.mid;
            }
        },
        changeValue(row, key, type) {
            if (key !== 'remarkMem' || key !== 'remarkDev') {
                row[key] = row[key] == 1 ? 0 : 1;
            }
            let param = {
                remark: row.remark,
                developer: row.developer,
                operation: row.operation,
                preview: row.preview,
                isDeleted: row.isDeleted,
                mid: row.mid
            };
            if (type === 0) {
                this.modifyInfo[row.mid] = {
                    mid: row.mid,
                    developer: row.developer,
                    operation: row.operation,
                    preview: row.preview,
                    isDeleted: row.isDeleted
                };
            } else if (type === 3) {
                this.previewModifyInfo[row.mid] = param;
                this.previewModifyInfo[row.mid].mid = row.mid;
            } else {
                let param2 = {
                    remark: row.remark,
                    buvid: row.buvid,
                    ctime: row.ctime,
                    isDelete: row.isDeleted
                };
                this.devicesModifyInfo[row.buvid] = param2;
                this.devicesModifyInfo[row.buvid].buvid = row.buvid;
            }
        },
        addDevices() {
            this.routeInfo = {
                path: '/rightsmng/'
            };
            if (this.devicesIsEdit && this.judgeSaveIsNeed('leaveSave')) {
                return;
            } else {
                this.addDevicesDialogVisible = true;
            }
        },
        closeAddDialog() {
            this.addDevicesDialogVisible = false;
        },
        formatDate(str) {
            return formatDate(new Date(str), 'yyyy-MM-dd HH:mm');
        }
    },
    mounted() {
        this.appId = this.$route.params.appId;
        // this.getList();
        this.getPreviewList();
    }
}
</script>
<style lang="less">
.m-right-manage {
    font-size: 14px;
    .header-manager {
        hieght: 23px;
        line-height: 23px;
        vertical-align: bottom;
        .icon-detail {
            vertical-align: -3px;
            display: inline-block;
            width: 14px;
            height: 14px;
            background: url(../../assets/icon_attention@2x.png) no-repeat
                center/contain;
            cursor: pointer;
        }
    }
    .title {
        font-size: 16px;
        font-weight: normal;
        color: #5c667e;
        margin: 0;
        margin-bottom: 15px;
    }
    .sub-title {
        font-size: 14px;
        .tips {
            font-size: 12px;
            color: #9aa7c1;
            margin-left: 8px;
            &.no-margin-tips {
                margin-left: 0;
            }
        }
    }
    .admin {
        padding: 20px 20px 15px;
        background-color: #fff;
        border: 1px solid #e0e5ec;
        margin-bottom: 10px;
        .manager {
            height: 60px;
            padding-left: 70px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: relative;
            .face-admin {
                position: absolute;
                left: 0;
                border-radius: 30px;
            }
            .name {
                margin-bottom: 6px;
                color: #222;
            }
            .mid {
                font-size: 12px;
                color: #6d757a;
            }
        }
    }
    .members {
        padding: 20px 20px 30px;
        background-color: #fff;
        border: 1px solid #e0e5ec;
        position: relative;
        margin-bottom: 10px;
        .op {
            position: absolute;
            right: 20px;
            top: 23px;
            .btn {
                margin-left: 18px;
                &.btn-add {
                    background: #789aff;
                    border: none;
                    border-radius: 2px;
                    color: #fff;
                    width: 85px;
                    padding: 10px 15px;
                }
                &.btn-1 {
                    color: #789aff;
                }
                &.btn-2 {
                    color: #9aa7c1;
                }
            }
        }

        .el-table {
            margin-top: 29px;
            margin-bottom: 30px;
            font-size: 12px;
            color: #212121;
            .deleted {
                position: absolute;
                left: 0;
                right: 0;
                top: 0;
                bottom: 0;
            }
            .len-remark {
                position: absolute;
                right: 6%;
                bottom: 20%;
            }
            .face {
                margin-top: 6px;
                margin-bottom: 2px;
                height: 70px;
                position: relative;
                line-height: 0;
                img {
                    border: 1px solid #e0e5ec;
                    &.face-err {
                        border: none;
                    }
                }
                .username {
                    line-height: 70px;
                }
                .delete {
                    display: block;
                    width: 16px;
                    height: 16px;
                    background: ~"url(../../assets/icon-del.png) no-repeat 0 0 / 16px 16px";
                    position: absolute;
                    top: 40%;
                    bottom: 0;
                    left: 0;
                    cursor: pointer;
                }
                &:hover {
                    .delete {
                        display: block;
                    }
                }
            }
            .buvid {
                display: position;
                .buvid_num {
                    margin-left: 20px;
                }
                .delete {
                    display: block;
                    width: 16px;
                    height: 16px;
                    background: ~"url(../../assets/icon-del.png) no-repeat 0 0 / 16px 16px";
                    position: absolute;
                    top: 40%;
                    bottom: 0;
                    left: 3%;
                    cursor: pointer;
                }
                &:hover {
                    .delete {
                        display: block;
                    }
                }
            }
            .el-icon-check {
                font-size: 18px;
                color: #43ce58;
                font-weight: bold;
            }
            .el-icon-minus {
                font-size: 16px;
                color: #9aa7c1;
                font-weight: bold;
            }
            .edit-dev {
                display: inline-block;
                border: 1px solid #e0e5ec;
                width: 22px;
                height: 22px;
                cursor: pointer;
                &.checked {
                    background: url(../../assets/selected@2x.png) no-repeat
                        center/ 22px;
                }
            }
            .redo {
                height: 76px;
                line-height: 76px;
                .el-button {
                    color: #789aff;
                    font-size: 12px;
                }
            }
            .admin-label {
                color: #43ce5b;
                background-color: rgba(103, 194, 58, 0.1);
                padding: 2px;
                margin-left: 4px;
            }
        }
        .pager {
            font-size: 12px;
            color: #9aa7c1;
            font-weight: normal;
            .el-pager {
                .number {
                    background: #ffffff;
                    border: 1px solid rgba(154, 167, 193, 0.5);
                    border-radius: 2px;
                    width: 30px;
                    height: 30px;
                    &.active {
                        background: #789aff;
                        color: #fff;
                    }
                }
            }
            .btn-prev,
            .btn-next {
                border-radius: 2px;
                padding: 1px 11px;
                height: 30px;
                background: #ffffff;
                border: 1px solid rgba(154, 167, 193, 0.5);

                &:disabled {
                    color: rgba(154, 167, 193, 0.5);
                    background: #f7f8fb;
                    border: 1px solid rgba(154, 167, 193, 0.2);
                }
                span {
                    font-size: 12px;
                }
                .more {
                    background: none;
                    color: #9aa7c1;
                }
            }
        }
    }
}
.el-popover {
    .content {
        font-size: 12px;
        line-height: 18px;
        padding: 4px 8px 8px;
        color: #5c667e;
        border: none;
    }
    &.title-tips {
        p {
            color: #9aa7c1;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/manage/Rights.vue